// extracted by mini-css-extract-plugin
module.exports = {"movie":"MovieItem_movie__3v1jI","rating":"MovieItem_rating__3GsTg","title":"MovieItem_title__JwISb"};